import { useState } from "react";
import Header from "../component/layout/header";
import "../assets/css/login.css"; // Reuse the SAME LOGIN CSS for identical design

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMsg("");

    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    const res = await fetch("https://kalakakshaaha.com/kks/api/v1/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    setMsg(data.message);
  };

  return (
    <>
      <Header />

      <div className="login-wrapper fadeIn">
        <div className="login-card">

          <h3 className="login-title">Forgot Password</h3>
          <p style={{ textAlign: "center", marginBottom: "15px" }}>
            Enter your registered email to receive the reset link
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Enter your email *"
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <p className={`validation-msg ${error ? "show" : ""}`}>
              {error}
            </p>

            <button className="login-btn">Send Reset Link</button>
          </form>

          {msg && (
            <p style={{ marginTop: "15px", color: "green", fontWeight: "600", textAlign: "center" }}>
              {msg}
            </p>
          )}

          <div className="login-bottom">
            <a href="/login">Back to Login</a>
          </div>
        </div>
      </div>
    </>
  );
}
